import { Deserializable, Deserialize } from "../helpers/serialization";


export class InfiniteZoomSettings extends Deserializable
{
    @Deserialize()
    selector:string = "zoomcontainer";

    @Deserialize()
    zoomspeed:number = 0.02;

    @Deserialize()
    pinchThrottle:number = 1;

    @Deserialize()
    crossfadeStart:number = 1.7;

    @Deserialize()
    crossfadeEnd:number = 5;

    @Deserialize()
    refocusStart:number = 7;

    @Deserialize()
    refocusEnd:number = 9;

    @Deserialize()
    refocusDuration:number = 2;

    @Deserialize()
    showInfoDuration:number = 0.75;

    @Deserialize()
    hideInfoDuration:number = 1;

    @Deserialize()
    simultanouesDownloads:number = 64;

    @Deserialize()
    idle:number = 10;

    @Deserialize()
    suspend:number = 300;

    @Deserialize()
    start:number = -1;  // Which image the zoom starts with, either index of image or -1 for random
}